import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import * as OnboardingService from 'Services/Apis/Onboarding';

import 'Assets/styles/default/components/Onboarding/OnboardingRedirectModal/OnboardingRedirectModal.less'

import { Col, Divider, Row, VertButton, VertModal, VertTypography } from '@vertem-core/vertice-ds';

import { onboardingUrl } from 'Constants/Onboarding';
import { hasEncryptedSSO } from 'Constants/Auth';

const OnboardingRedirectModal = (props) => {
  const { open, handleClose } = props;

  const user = useSelector(state => (
    state.oidc.user
  ));

  const handleContinue = () => {
    if (!hasEncryptedSSO) {
      location.href = onboardingUrl + user.profile['custom:campaign_id'];
      return;
    }

    OnboardingService.encrypt(user)
      .then(({ data: encryption }) => location.href = `${onboardingUrl}?sso=${encryption.data}`)
      .catch(err => console.log(err));
  }

  return (
    <VertModal
      className='onboarding-redirect-modal'
      open={open}
      onCancel={handleClose}
      destroyOnClose
    >
      <VertTypography.Title>
        Verificação em duas etapas pendente
      </VertTypography.Title>

      <VertTypography.Paragraph type='light'>
        Ao clicar em <strong>continuar</strong> você será redirecionado para a página de verificação em duas etapas.
      </VertTypography.Paragraph>

      <Divider />

      <Row justify='end'>
        <Col className='action-btn-group'>
          <VertButton
            onClick={handleClose}
          >
            Cancelar
          </VertButton>

          <VertButton
            type='highlight'
            onClick={handleContinue}
          >
            Continuar
          </VertButton>
        </Col>
      </Row>
    </VertModal>
  );
}

export default OnboardingRedirectModal;
